import 'common/css/app.css'
import './index.css'
import 'common/js/global.js'

$(function(){
  $(window).resize(function(){
    Affix()
  })
  hoverCss()
  Affix()
  wayPoint()
  locationTab()
})

function hoverCss() {
  $('.solution-wrapper').find('.value-item').hover(function() {
    $(this).addClass('active')
  },function(){
    $(this).removeClass('active')
  })
}
function wayPoint() {
  $('.page').waypoint(function (direction) {
      if (direction === 'down') {
          $(this.element).find('.state').addClass('animated slideInUp');
      }
  }, {offset: '70%'});
}
function Affix() {
  var affixTop = $(".solution-wrapper .offsetTop").offset().top
  $('#affixBox').affix({
    offset: {
      top: affixTop
    }
  })
}
function locationTab () {
  if (window.location.hash) {
    // '#'需要转义
    $('#myTab a[href=\\'+ window.location.hash +']').tab('show')
  }else {
    $('#myTab a[href="#bus"]').tab('show')
  }
}




// WEBPACK FOOTER //
// ./src/solution/index.js